"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var GameContext_1 = require("../GameProvider/GameContext");
var Menu_1 = require("../Menu");
var useSoundControls_1 = __importDefault(require("./useSoundControls"));
function SoundButton() {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, useSoundControls_1.default)(), mute = _b.mute, unmute = _b.unmute, muted = _b.muted;
    var hasSounds = (_a = (0, react_1.useContext)(GameContext_1.gameContext)) === null || _a === void 0 ? void 0 : _a.hasSounds;
    if (!hasSounds)
        return null;
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ css: Menu_1.menuButtonCss, onClick: function () { return muted ? unmute() : mute(); } }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: muted ? free_solid_svg_icons_1.faVolumeMute : free_solid_svg_icons_1.faVolumeUp }), muted ? t('Enable sound') : t('Mute sound')] })));
}
exports.default = SoundButton;
